import {
  Box,
  Devider,
  DropdownOptions,
  FilterProvider,
  FormProvider,
  ModalProvider,
  Spinner,
  TooltipPopup,
} from "dash-ui";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { useGetBrokerByIdQuery } from "gql/generated.graphql";
import { useMemo } from "react";
import { useParams } from "react-router";

import BlockBrokerModal from "pages/brokers/components/BlockBrokerModal/BlockBrokerModal";
import UnblockBrokerModal from "pages/brokers/components/UnblockBrokerModal/UnblockBrokerModal";
import { useBrowserTabTitle } from "common/hooks/use-browser-tab-title/use-browser-tab-title";

import { FormFieldsList } from "./BrokerDetailsPage.constants";
import BrokerInfoForm from "./components/BrokerInfoForm/BrokerInfoForm";
import LicenseInfo from "./components/LicenseInfo/LicenseInfo";
import PageHeader from "./components/PageHeader/PageHeader";

const BrokerDetailsPage = () => {
  const theme = useTheme();
  const { id: brokerId = "" } = useParams();
  const { t } = useTranslation();

  const { data, loading } = useGetBrokerByIdQuery({ variables: { brokerId } });

  const broker = useMemo(() => data?.getSingleBrokerById, [data]);

  useBrowserTabTitle(
    `${
      broker
        ? broker?.profile.lastName
          ? `${broker?.profile.firstName} ${broker?.profile.lastName}`
          : broker?.profile.firstName || ""
        : "Agents"
    } ${t("common:labels.dashSuffix")}`
  );

  return (
    <FilterProvider>
      <ModalProvider>
        <>
          <DropdownOptions />
          <TooltipPopup />
          <Box w="100%" pos="relative">
            {loading ? (
              <Spinner fullContent />
            ) : (
              <>
                <PageHeader broker={broker} />
                <Devider color={theme.colors.n30} />
                <FormProvider fieldsList={FormFieldsList}>
                  <BrokerInfoForm broker={broker} />
                </FormProvider>
                <Devider color={theme.colors.n30} />
                <LicenseInfo broker={broker} />

                <BlockBrokerModal />
                <UnblockBrokerModal />
              </>
            )}
          </Box>
        </>
      </ModalProvider>
    </FilterProvider>
  );
};

export default BrokerDetailsPage;
